var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpouseHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97,
    height: 35,
    viewBox: "0 0 97 35",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spouseHouse-clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 35,
    transform: "translate(-29.988 1.749)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "spouseHouse",
    transform: "translate(29.988 -1.749)",
    clipPath: "url(#spouseHouse-clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.989,41.509V25.615S28,25.65,28,15.636H15.171c0,10.014-4.989,9.978-4.989,9.978V41.509Z",
    transform: "translate(-2.905 -5.76)",
    fill: "none",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.309,9.127H25.182V5.564a3.564,3.564,0,0,1,7.127,0Z",
    transform: "translate(-10.065 0.749)",
    fill: "none",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.782,34.727C4.112,36.188,2,37.4,2,43.138v7.484",
    transform: "translate(1 -14.872)",
    fill: "none",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.818,34.727c2.648,1.461,4.743,2.673,4.743,8.41v7.484",
    transform: "translate(-24.2 -14.872)",
    fill: "none",
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.394,47.122c-6.878,0-7.234-6.735-7.234-6.735H32.593C32.629,40.386,32.272,47.122,25.394,47.122Z",
    transform: "translate(-6.713 -17.573)",
    fill: "none",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpouseHouse);
export default __webpack_public_path__ + "static/media/spouseHouse.606cf208f2c8f24c0c9bc76abf8df436.svg";
export { ForwardRef as ReactComponent };